export default __webpack_public_path__ + "static/media/IconMail.127cc436.svg";